import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import user from './modules/user';
import snackbar from './modules/snackbar';
import exportHistoric from './modules/exportHistoric';

Vue.use(Vuex);

export default () => {
  const store = new Vuex.Store({
    modules: {
      user,
      snackbar,
      exportHistoric,
    },
    strict: process.env.NODE_ENV !== 'production',
  });

  if (process.env.NODE_ENV === 'development') {
    store.subscribeAction((action) => {
      console.log(action.type, action.payload);
    });
  }
  return store;
};
